export enum AuthRecoveryCodeDeliveryFlow {
    AccountRecovery = 'account_recovery',
    Registration = 'registration',
}
